import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { getHPDViolationById } from '../../../../../../sevices/violationsApi';
import './styles.scss';
import moment from 'moment';

// Component imports
import DetailHeader from './components/DetailHeader';
import ViolationInfoCard from './components/ViolationInfoCard';
import DocumentsSection from './components/DocumentsSection';
import NotesSection from './components/NotesSection';
import { useHPDTicketById } from '../../../../../../reactQuery/violations';
import Loader from '../../../../../../components/Loader';

function ViolationDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { responseData, isLoading, isError, refetch } = useHPDTicketById(id);

  console.log(responseData);


  useEffect(() => {
    // In a real app, fetch the violation data
    const fetchViolation = async () => {
      try {
          refetch();
      } catch (err) {
        console.error(err);
      }
    };

    fetchViolation();
  }, [id]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleStatusChange = (newStatus) => {
    // setViolation(prev => ({
    //   ...prev,
    //   status: newStatus
    // }));
  };

  const handleAddNote = (noteText) => {
    if (!noteText.trim()) return;
    
    const newNote = {
      id: Date.now(),
      date: moment().format('YYYY-MM-DD'),
      text: noteText,
      editing: false
    };
    
    // setViolation(prev => ({
    //   ...prev,
    //   notes: [newNote, ...prev.notes]
    // }));
  };

  const handleDeleteNote = (noteId) => {
    // setViolation(prev => ({
    //   ...prev,
    //   notes: prev.notes.filter(note => note.id !== noteId)
    // }));
  };

  if (isLoading) {
    return (
      <div className="loader-center">
       <Loader color="black"/>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="violation-detail-error">
        <Typography color="error">{isError}</Typography>
        <Button variant="outlined" onClick={handleBack}>
          Go Back
        </Button>
      </div>
    );
  }

  return (
    <div className="violation-detail-container">
      <DetailHeader title="HPD Violation Ticket Details" />
      
      <ViolationInfoCard 
        violation={responseData} 
        onStatusChange={handleStatusChange} 
        refetch={refetch}
      />
      
      <DocumentsSection documents={responseData?.attachments || []} ticketId={id} refetch={refetch}/>
      
      <NotesSection 
      />
    </div>
  );
}

export default ViolationDetail;